import {SxType} from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
	root:{
		padding:'3px 6px'
	},
	info: {
		display: 'flex',
		alignItems: 'center',
		gap: '10px'
	}
}